export interface ComicChapter {
  id: string;
  number: number;
  title: string;
  createdAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: ComicChapter[];
  updatedAt: string;
  createdAt: string;
}

export const featuredComics: Comic[] = [
  {
    id: '1',
    slug: 'sweet-secret-office',
    title: '甜蜜的办公室秘密',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20cover%20art%2C%20young%20couple%20in%20modern%20office%20setting%2C%20soft%20warm%20lighting%2C%20elegant%20illustration%2C%20clean%20composition%20with%20subtle%20pink%20accents%2C%20professional%20digital%20art%2C%20simple%20light%20background%20with%20gentle%20gradient&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    description: '入职第一天就发现直属上司是大学时期的前男友？而且他似乎还对当年的事耿耿于怀……一段甜蜜又纠结的办公室恋爱故事就此展开。',
    category: '浪漫爱情',
    categorySlug: 'romance',
    tags: ['办公室', '恋爱', '治愈'],
    status: '连载中',
    rating: 4.8,
    views: 1250000,
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话${i < 5 ? ['', '初遇', '重逢', '心跳', '靠近', '抉择'][i] : ''}`,
      createdAt: new Date(2026, 6, 30 - i * 7).toISOString().split('T')[0],
    })),
    updatedAt: '2026-07-28',
    createdAt: '2025-06-15',
  },
  {
    id: '2',
    slug: 'revenge-swordmaster',
    title: '复仇的剑术大师',
    author: '李东赫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20fantasy%20cover%20art%2C%20swordsman%20with%20flowing%20cape%20holding%20glowing%20sword%2C%20dramatic%20lighting%2C%20epic%20illustration%20with%20warm%20amber%20tones%2C%20cinematic%20composition%2C%20simple%20gradient%20background&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    description: '被最信任的同伴背叛后，剑术大师韩振宇重生回到十年前。带着前世的记忆和绝世剑法，这一次他要改写命运，向所有背叛者复仇。',
    category: '热血动作',
    categorySlug: 'action',
    tags: ['重生', '复仇', '武侠'],
    status: '连载中',
    rating: 4.9,
    views: 2380000,
    chapters: Array.from({ length: 62 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 7, 1 - i * 5).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-01',
    createdAt: '2025-03-10',
  },
  {
    id: '3',
    slug: 'goddess-descends',
    title: '女神降临',
    author: '朴彩英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20beauty%20transformation%20cover%20art%2C%20gorgeous%20young%20woman%20with%20makeup%20looking%20in%20mirror%2C%20soft%20glamorous%20lighting%2C%20elegant%20digital%20illustration%2C%20warm%20peach%20tones%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    description: '因为外貌被欺凌的女孩通过化妆技术蜕变为校园女神，却意外卷入了学校两大男神的感情漩涡中。美丽的外表下，隐藏着不为人知的秘密。',
    category: '浪漫爱情',
    categorySlug: 'romance',
    tags: ['校园', '化妆', '逆袭'],
    status: '已完结',
    rating: 4.7,
    views: 4500000,
    chapters: Array.from({ length: 88 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 2, 15 - i * 4).toISOString().split('T')[0],
    })),
    updatedAt: '2026-03-15',
    createdAt: '2024-01-20',
  },
  {
    id: '4',
    slug: 'dungeon-hunter',
    title: '地下城猎人',
    author: '郑宇成',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dungeon%20fantasy%20cover%20art%2C%20hunter%20with%20dual%20daggers%20in%20dark%20dungeon%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%20with%20warm%20orange%20highlights%2C%20epic%20illustration%2C%20dark%20gradient%20background&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    description: '平凡上班族突然觉醒为S级猎人，被卷入一座神秘地下城的生存游戏。在这里，只有不断变强才能活下去。而他，将登顶最强猎人之位。',
    category: '热血动作',
    categorySlug: 'action',
    tags: ['系统', '升级', '地下城'],
    status: '连载中',
    rating: 4.9,
    views: 3200000,
    chapters: Array.from({ length: 73 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 7, 3 - i * 4).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-03',
    createdAt: '2024-11-05',
  },
  {
    id: '5',
    slug: 'nightmare-detective',
    title: '噩梦侦探',
    author: '崔敏俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mystery%20thriller%20cover%20art%2C%20detective%20in%20trench%20coat%20under%20streetlamp%20at%20night%2C%20atmospheric%20noir%20lighting%2C%20suspenseful%20illustration%2C%20warm%20sepia%20undertones%2C%20simple%20dark%20background&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    description: '能进入他人梦境的前刑警，利用这一能力破解了一桩桩诡异案件。但当梦境中的凶手开始注意到他时，一切变得危险起来。',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    tags: ['推理', '超能力', '悬疑'],
    status: '连载中',
    rating: 4.6,
    views: 980000,
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 6, 25 - i * 7).toISOString().split('T')[0],
    })),
    updatedAt: '2026-07-25',
    createdAt: '2025-09-01',
  },
  {
    id: '6',
    slug: 'cat-cafe-magic',
    title: '猫咪咖啡馆的魔法师',
    author: '尹恩惠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comedy%20cover%20art%2C%20magical%20girl%20with%20cats%20in%20cozy%20cafe%20setting%2C%20warm%20cheerful%20lighting%2C%20charming%20illustration%2C%20soft%20pastel%20colors%20with%20warm%20tones%2C%20simple%20bright%20background&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    description: '失业女孩在街角发现了一家神秘的猫咪咖啡馆，每位猫咪服务员都拥有不可思议的魔法。在这里，她找到了新的人生方向和一段奇妙的缘分。',
    category: '轻松喜剧',
    categorySlug: 'comedy',
    tags: ['奇幻', '治愈', '猫'],
    status: '连载中',
    rating: 4.5,
    views: 720000,
    chapters: Array.from({ length: 32 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 6, 20 - i * 8).toISOString().split('T')[0],
    })),
    updatedAt: '2026-07-20',
    createdAt: '2025-11-15',
  },
];

export const latestComics: Comic[] = [
  {
    id: '7',
    slug: 'palace-conspiracy',
    title: '后宫谋略：王的秘密',
    author: '韩智敏',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20historical%20palace%20drama%20cover%20art%2C%20elegant%20woman%20in%20traditional%20hanbok%20in%20ancient%20palace%2C%20mysterious%20atmosphere%2C%20beautiful%20illustration%20with%20warm%20golden%20tones%2C%20simple%20elegant%20background&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    description: '一觉醒来穿越成朝鲜王朝的王妃，却发现宫中暗流涌动，每个人都心怀鬼胎。为了活下去，她必须在这场权力的游戏中胜出。',
    category: '古风历史',
    categorySlug: 'historical',
    tags: ['穿越', '宫斗', '权谋'],
    status: '连载中',
    rating: 4.7,
    views: 560000,
    chapters: Array.from({ length: 25 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 7, 2 - i * 6).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-02',
    createdAt: '2026-04-01',
  },
  {
    id: '8',
    slug: 'shadow-classroom',
    title: '暗影教室',
    author: '宋民奎',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20horror%20school%20cover%20art%2C%20students%20in%20dark%20classroom%20with%20eerie%20atmosphere%2C%20spooky%20moody%20lighting%2C%20thriller%20illustration%20with%20warm%20shadow%20tones%2C%20simple%20dark%20gradient%20background&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    description: '放学后的教室里，总会出现不属于这个世界的影子。当七个学生被留下来值日的那天晚上，恐怖的事情开始接连发生。',
    category: '恐怖灵异',
    categorySlug: 'horror',
    tags: ['校园', '灵异', '恐怖'],
    status: '连载中',
    rating: 4.4,
    views: 380000,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 6, 15 - i * 8).toISOString().split('T')[0],
    })),
    updatedAt: '2026-07-15',
    createdAt: '2026-03-20',
  },
  {
    id: '9',
    slug: 'city-lawyer',
    title: '律师的品格',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20drama%20legal%20cover%20art%2C%20confident%20lawyer%20in%20courtroom%20setting%2C%20professional%20atmosphere%2C%20warm%20sophisticated%20lighting%2C%20clean%20illustration%20style%2C%20simple%20elegant%20background&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    description: '新人律师朴瑞俊接手了一桩看似普通的离婚案，却发现背后牵扯着财阀家族的惊天秘密。在正义与利益之间，他将做出怎样的选择？',
    category: '都市剧情',
    categorySlug: 'drama',
    tags: ['职场', '法律', '社会'],
    status: '连载中',
    rating: 4.6,
    views: 450000,
    chapters: Array.from({ length: 28 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 6, 28 - i * 7).toISOString().split('T')[0],
    })),
    updatedAt: '2026-07-28',
    createdAt: '2026-02-14',
  },
  {
    id: '10',
    slug: 'otherworld-farmer',
    title: '异世界悠闲农家',
    author: '姜道贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20farming%20cover%20art%2C%20young%20farmer%20in%20magical%20countryside%20with%20mythical%20creatures%2C%20warm%20sunny%20lighting%2C%20peaceful%20pastoral%20illustration%2C%20gentle%20warm%20color%20palette%2C%20simple%20natural%20background&width=800&height=1120&seq=comic-cover-10&orientation=portrait',
    description: '被召唤到异世界后，勇者姜道贤选择了一条与众不同的道路——开荒种地！用现代农业知识在魔法世界经营超级农场，闲暇时与精灵龙娘喝杯茶。',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    tags: ['异世界', '种田', '休闲'],
    status: '连载中',
    rating: 4.8,
    views: 890000,
    chapters: Array.from({ length: 35 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 7, 1 - i * 5).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-01',
    createdAt: '2026-01-10',
  },
  {
    id: '11',
    slug: 'secretary-villainess',
    title: '恶女秘书的生存法则',
    author: '林秀晶',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20office%20drama%20cover%20art%2C%20elegant%20secretary%20woman%20in%20luxury%20office%2C%20confident%20expression%2C%20sophisticated%20lighting%2C%20dramatic%20illustration%2C%20warm%20champagne%20tones%2C%20simple%20modern%20background&width=800&height=1120&seq=comic-cover-11&orientation=portrait',
    description: '穿越成为小说中的恶毒女配，为了不被主角团消灭，她决定利用现代职场经验在反派公司里步步为营。但总裁大人看她的眼神越来越奇怪了……',
    category: '都市剧情',
    categorySlug: 'drama',
    tags: ['穿越', '职场', '女配'],
    status: '连载中',
    rating: 4.5,
    views: 670000,
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 6, 22 - i * 7).toISOString().split('T')[0],
    })),
    updatedAt: '2026-07-22',
    createdAt: '2026-03-01',
  },
  {
    id: '12',
    slug: 'laugh-king',
    title: '搞笑天王',
    author: '车太贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20cover%20art%2C%20funny%20expressive%20character%20making%20silly%20face%2C%20bright%20cheerful%20lighting%2C%20cartoonish%20dynamic%20illustration%2C%20warm%20vibrant%20colors%2C%20simple%20bright%20background&width=800&height=1120&seq=comic-cover-12&orientation=portrait',
    description: '天生搞笑圣体的车太贤转学到一所严肃高中，用无敌的幽默感征服了全校师生。但他的搞笑背后，隐藏着一个让人泪目的秘密。',
    category: '轻松喜剧',
    categorySlug: 'comedy',
    tags: ['校园', '搞笑', '治愈'],
    status: '已完结',
    rating: 4.9,
    views: 2100000,
    chapters: Array.from({ length: 55 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: new Date(2026, 1, 10 - i * 4).toISOString().split('T')[0],
    })),
    updatedAt: '2026-02-10',
    createdAt: '2024-09-01',
  },
];

export const allComics: Comic[] = [...featuredComics, ...latestComics];

export function getComicsByCategory(slug: string): Comic[] {
  return allComics.filter((c) => c.categorySlug === slug);
}

export function getComicBySlug(slug: string): Comic | undefined {
  return allComics.find((c) => c.slug === slug);
}